import 'owl.carousel'
import modal from 'bootstrap/js/src/modal'
//import './tablet-banner'

(function ($){
    $(document).ready(function () {
        /**
         * Product inner page carousel
         */
        $('.product__carousel.owl-carousel').owlCarousel({
            loop: 1,
            margin: 25,
            nav: 1,
            items: 1,
            navText: [
                `<span class="product__carousel-arrow _prev">
                <svg width="69" height="42" viewBox="0 0 69 42" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M68.5002 19.9977C68.7762 19.9977 69 20.2217 69 20.4981C69 20.7745 68.7762 20.9986 68.5002 20.9986L1.77251 20.9986L20.8433 41.0794C21.0536 41.29 21.0536 41.6314 20.8433 41.842C20.6329 42.0527 20.292 42.0527 20.0817 41.842L0.157761 20.907C-0.0525892 20.6964 -0.0525892 20.3549 0.157761 20.1443C0.16008 20.142 0.1624 20.1397 0.164719 20.1375L20.1443 0.146586C20.3396 -0.0488613 20.656 -0.0488613 20.8512 0.146586C21.0463 0.342032 21.0463 0.658914 20.8512 0.85436L1.7179 19.9977L68.5002 19.9977Z" fill="#A1A19F"/></svg>
            </span>`,
                `<span class="product__carousel-arrow _next">
                <svg width="69" height="42" viewBox="0 0 69 42" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.49977 22.0023C0.223774 22.0023 2.41142e-07 21.7783 2.44438e-07 21.5019C2.47734e-07 21.2255 0.223774 21.0014 0.49977 21.0014L67.2275 21.0014L48.1567 0.920647C47.9464 0.710038 47.9464 0.368569 48.1567 0.15796C48.3671 -0.0526499 48.708 -0.0526499 48.9183 0.15796L68.8422 21.093C69.0526 21.3036 69.0526 21.6451 68.8422 21.8557C68.8399 21.858 68.8376 21.8603 68.8353 21.8625L48.8557 41.8534C48.6604 42.0489 48.344 42.0489 48.1488 41.8534C47.9537 41.658 47.9537 41.3411 48.1488 41.1456L67.2821 22.0023L0.49977 22.0023Z" fill="#A1A19F"/></svg>
            </span>`,
            ],
            // responsive: {
            //     0: {
            //         items: 1
            //     },
            //     768: {
            //         items: 2
            //     },
            //     1024: {
            //         items: 3
            //     }
            // }
        });
    })

    /**
     * Home page product carousel
     */
    $('.section__slider.owl-carousel').owlCarousel({
        items: 1,
        margin: 25,
        dots: 1,
    })

    /**
     * Promo Gallery carousel
     */
    $('.product__pg-content-thumbs.owl-carousel').owlCarousel({
        items: 1,
        loop: true,
        nav: 1,
        navText: ['<svg width="69" height="42" viewBox="0 0 69 42" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M68.5002 19.9977C68.7762 19.9977 69 20.2217 69 20.4981C69 20.7745 68.7762 20.9986 68.5002 20.9986L1.77251 20.9986L20.8433 41.0794C21.0536 41.29 21.0536 41.6314 20.8433 41.842C20.6329 42.0527 20.292 42.0527 20.0817 41.842L0.157761 20.907C-0.0525892 20.6964 -0.0525892 20.3549 0.157761 20.1443C0.16008 20.142 0.1624 20.1397 0.164719 20.1375L20.1443 0.146586C20.3396 -0.0488613 20.656 -0.0488613 20.8512 0.146586C21.0463 0.342032 21.0463 0.658914 20.8512 0.85436L1.7179 19.9977L68.5002 19.9977Z" fill="#A1A19F"/></svg>', '<svg width="69" height="42" viewBox="0 0 69 42" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.49977 22.0023C0.223774 22.0023 2.41142e-07 21.7783 2.44438e-07 21.5019C2.47734e-07 21.2255 0.223774 21.0014 0.49977 21.0014L67.2275 21.0014L48.1567 0.920647C47.9464 0.710038 47.9464 0.368569 48.1567 0.15796C48.3671 -0.0526499 48.708 -0.0526499 48.9183 0.15796L68.8422 21.093C69.0526 21.3036 69.0526 21.6451 68.8422 21.8557C68.8399 21.858 68.8376 21.8603 68.8353 21.8625L48.8557 41.8534C48.6604 42.0489 48.344 42.0489 48.1488 41.8534C47.9537 41.658 47.9537 41.3411 48.1488 41.1456L67.2821 22.0023L0.49977 22.0023Z" fill="#A1A19F"/></svg>'],
        dots: 1,
        dotsData: 1,
    })

    const $productThumbItems = $('.product__pg-types-item')
    const $productThumbContents = $('.product__pg-content')

    $productThumbItems.on('click', function(e) {
        const $thumbItem = $(this)
        const itemId = $thumbItem.data('id')

        e.preventDefault()

        $productThumbItems.removeClass('_active')
        $thumbItem.addClass('_active')

        $productThumbContents.removeClass('_active')
        $productThumbContents.filter(`[data-id=${itemId}]`).addClass('_active')
    })
})(jQuery)
